var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{attrs:{"id":"my-chart-id","options":_vm.chartOptions,"data":_vm.chartData,"css-classes":_vm.cssClasses,"styles":_vm.styles,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }